/* Китайский перевод чрома: ключ — русская строка из вызова t().
 *
 * Перевод машинный. Для витрины годится; перед эксплуатацией его обязан
 * вычитать носитель языка — иначе в интерфейсе окажется то, чего никто не
 * проверял. Доменные данные (номера, названия документов, имена людей)
 * остаются на языке источника и сюда не попадают.
 *
 * Чего в словаре нет, показывается по-английски: см. t() в ./lang.
 * Отраслевые сокращения (MDR, VDR, TRM, CRS, ACSR, AFD, SLA) не переводятся —
 * они одинаковы во всей проектной документации независимо от языка.
 */
export const ZH: Record<string, string> = {
  ' (реестр уже есть)': '（清单已存在）',
  ' · наследует': ' · 继承',
  ' · своя ветка': ' · 独立分支',
  ' в очереди': ' 在队列中',
  ' строк импортировано.': ' 行已导入。',
  'S-кривая выпуска (план / прогноз / факт)': 'S 曲线（计划 / 预测 / 实际）',
  'S-кривая выпуска документации': '文件签发 S 曲线',
  'S-кривая появится вместе с агрегатами дашборда проекта.': 'S 曲线将随项目看板汇总一并推出。',
  'SLA, дн': 'SLA，天',
  'Авто-консолидация': '自动汇总',
  'Админ.': '管理',
  'Администрирование': '系统管理',
  'Администрирование системы': '系统管理',
  'Активна': '启用',
  'Аннулирование…': '作废中…',
  'Аннулированный документ не правится': '已作废的文件不可编辑',
  'Аннулировать': '作废',
  'Аннулировать выбранные строки': '作废所选行',
  'Аннулировать документ': '作废文件',
  'Аннулируем…': '作废中…',
  'Без кода': '无编码',
  'Без файла': '无文件',
  'Будет создан номер': '将生成编号',
  'Было': '变更前',
  'Бэклог рассмотрения': '待审积压',
  'В CRS': '加入 CRS',
  'В Excel не найдено строк маршрута.': 'Excel 中未找到流程行。',
  'В бэклоге': '在积压中',
  'В заказе пока нет документов': '该订单暂无文件',
  'В маршруте нужен хотя бы один шаг': '流程至少需要一个步骤',
  'В проекте нет контрактов — заведите его в «Администрирование»': '项目中没有合同 —— 请在“系统管理”中创建',
  'В проекте нет контрактов': '项目中没有合同',
  'В работу (AFD) за неделю': '本周转入施工（AFD）',
  'В реестре пока нет документов': '该清单暂无文件',
  'В трансмиттале нет документов': '该传递单没有文件',
  'Ваш ответ': '您的回复',
  'Ваша роль': '您的角色',
  'Ваша роль:': '您的角色：',
  'Ваше рассмотрение': '您的审查',
  'Вернуть на доработку': '退回修改',
  'Вернуть состав, ширины и порядок столбцов': '恢复列的组成、宽度和顺序',
  'Версии файлов внутри ревизии': '版次内的文件版本',
  'Весь проект': '整个项目',
  'Весь реестр': '整个清单',
  'Возвратный TRM выпущен': '退回 TRM 已签发',
  'Возвратный TRM уже выпущен': '退回 TRM 已签发',
  'Входит в номер документа': '计入文件编号',
  'Выпустить возвратный TRM': '签发退回 TRM',
  'Возвратный трансмиттал — содержит CRS и сопроводительные документы по предыдущей партии.': '退回传递单——包含上一批次的 CRS 及随附文件。',
  'Возвращено (исх. TRM + CRS)': '已退回',
  'Войти': '登录',
  'Вперёд': '下一页',
  'Все': '全部',
  'Все действия': '全部操作',
  'Все дисциплины': '全部专业',
  'Все документы поданы, замечаний без ответа нет.': '全部文件已提交，没有未回复的意见。',
  'Все документы, трансмитталы и замечания изолированы в рамках проекта. Вы видите только проекты, к которым назначены.': '所有文件、传递单和意见按项目隔离。您只能看到已分配给您的项目。',
  'Все контракты уже ведутся': '所有合同均已建有清单',
  'Все проекты и выход': '全部项目 / 退出',
  'Все реестры': '全部清单',
  'Всего': '合计',
  'Всего задач': '任务总数',
  'Вход в систему': '登录系统',
  'Вход выполняется на сервере единой учётной записи. Пароль в это приложение не передаётся.': '登录在统一身份服务器上完成。密码不会传入本应用。',
  'Входящие': '收件',
  'Входящий': '接收',
  'Выберите документы из реестра MDR и укажите назначение': '从 MDR 清单中选择文件并指定用途',
  'Выберите документы — пакет уйдёт заказчику на рассмотрение': '选择文件——该批次将提交业主审查',
  'Выберите заказ слева.': '请在左侧选择订单。',
  'Выберите замечание': '请选择一条意见',
  'Выберите проект': '请选择项目',
  'Выберите трансмиттал в очереди': '从队列中选择一份传递单',
  'Выберите хотя бы один документ': '请至少选择一份文件',
  'Выбран': '已选',
  'Выбрано не всё': '并非全部选中',
  'Выбрать все': '全选',
  'Выгрузить журнал': '导出日志',
  'Выгрузка не удалась': '导出失败',
  'Выгрузка пакета появится вместе с потоковым экспортом': '批量下载将随流式导出一并推出',
  'Выгрузка появится вместе с потоковым экспортом': '导出将随流式下载一并推出',
  'Выйти': '退出',
  'Выпуск создаёт исходящий TRM и замечания по кодам C и D': '签发将生成外发 TRM 以及 C、D 类意见',
  'Выпускается…': '签发中…',
  'Выпуск…': '提出中…',
  'Выпустить CRS': '签发 CRS',
  'Выпустить CRS + исх. TRM': '签发 CRS + 外发 TRM',
  'Выпустить замечание (CRS)': '提出意见（CRS）',
  'Выпустить ревизию': '签发新版次',
  'Выход': '退出',
  'Голоса рецензентов': '审查人意见',
  'Готовность': '完成度',
  'Готовность AFD': 'AFD 完成度',
  'Группировка': '分组',
  'ДД.ММ.ГГГГ': '日日.月月.年年年年',
  'Дата': '日期',
  'Дата регистрации': '登记日期',
  'Двигаем…': '顺延中…',
  'Действие': '操作',
  'Действует прежняя согласованная редакция': '此前批准的版次继续有效',
  'Дисц.': '专业',
  'Дисциплина': '专业',
  'Дисциплина / пакет': '专业',
  'Длина': '长度',
  'Дней': '天',
  'Добавить': '新增',
  'Добавить шаг маршрута': '新增流程步骤',
  'Док.': '文件数',
  'Документ': '文件',
  'Документ не выбран': '未选择文件',
  'Документ не найден': '未找到文件',
  'Документ передаётся только в составе TRM': '文件仅能通过 TRM 传递',
  'Документ создан': '文件已创建',
  'Документ уже аннулирован': '文件已作废',
  'Документов': '文件数',
  'Документов получено': '已接收',
  'Документы': '文件',
  'Документы в ожидании рассмотрения и переиздания': '待审查 / 待重发的文件',
  'Документы в составе TRM': '本传递单内的文件',
  'Документы под рассмотрением': '审查中的文件',
  'Документы подрядчика в реестрах MDR': '该承包商在 MDR 清单中的文件',
  'Документы поставщика': '供应商文件',
  'Документы реестра': '清单内文件',
  'Документы реестров MDR': 'MDR 清单文件',
  'Доступ дополнительно фильтруется по дисциплинам и проекту': '访问权限还会按专业和项目进一步过滤',
  'Доступ запрещён: журнал событий открыт не каждой роли. Право выдаёт администратор проекта.': '无权访问：事件日志并非对所有角色开放。权限由项目管理员授予。',
  'Доступ запрещён: у вашей роли нет права на этот раздел. Право выдаёт администратор проекта.': '无权访问：您的角色没有该模块的权限。权限由项目管理员授予。',
  'Доступ назначен, но токен выдан раньше. Выйдите и войдите заново.': '权限已分配，但令牌签发在先。请退出后重新登录。',
  'Доступные проекты': '可用项目',
  "Единая платформа документооборота стороны Заказчика: трансмитталы, реестры MDR/VDR, замечания и контроль сроков.": '业主方统一的文档管理平台：传递单、MDR/VDR 清单、意见与进度管控。',
  'Единая таблица всех документов проекта — группировка и фильтрация по любому атрибуту': '项目全部文件汇总为一张表——可按任意属性分组和过滤',
  'Есть несохранённые изменения': '存在未保存的更改',
  'Журнал аудита': '审计日志',
  'Журнал в Excel': '导出日志',
  'За 30 дней': '近 30 天',
  'За 7 дней': '近 7 天',
  'За квартал': '本季度',
  'За месяц': '本月',
  'Завершить рассмотрение': '提交审查',
  'Загрузить Excel': '导入 Excel',
  'Загрузка': '上传',
  'Загрузка их не трогает: исключение из объёма — решение, а не следствие файла. Аннулируйте строки, если они исключены.': '导入不会改动它们：移出范围是决定，而不是文件带来的结果。若确已移出范围，请作废这些行。',
  'Загрузка остановилась на шаге': '上传中断于步骤',
  'Загрузка файлов реестра': '批量上传清单文件',
  'Загрузка…': '加载中…',
  'Задан титулом': '由项目标题确定',
  'Задач нет': '暂无任务',
  'Заказ · поставщик · предмет поставки': '采购订单 · 供应商 · 供货内容',
  'Заказ не выбран': '未选择采购订单',
  'Заказ, поставщик, предмет…': '订单、供应商、标的…',
  'Заказов пока нет': '暂无采购订单',
  'Заказчик': '业主',
  'Заказчик · замечание': '业主 · 意见',
  'Заказчик · рецензент': '业主 · 审查人',
  'Заказы на поставку': '采购订单',
  'Закрыт': '已关闭',
  'Закрытие недоступно до получения ACSR': '收到 ACSR 之前无法关闭',
  'Закрыто': '已关闭',
  'Закрытые': '已关闭',
  'Закрыть': '关闭',
  'Закрыть замечание': '关闭意见',
  'Закрыть реестр': '关闭清单',
  'Зам.': '意见',
  'Замечание выпускается на один документ': '一条意见只针对一份文件',
  'Замечание закрыто заказчиком': '业主已关闭',
  'Замечание закрыто и зафиксировано в аудите': '意见已关闭并记入审计',
  'Замечание не найдено в реестре': '清单中未找到该意见',
  'Замечаний нет': '暂无意见',
  'Замечаний по документу нет.': '该文件没有意见。',
  'Замечания': '意见',
  'Замечания (CRS / ACSR)': '意见（CRS / ACSR）',
  'Замечания CRS и ответы ACSR': 'CRS 意见与 ACSR 回复',
  'Замечания заказчика': '业主意见',
  'Замечания на листе': '图面意见',
  'Замечания по ревизиям': '各版次意见',
  'Заморожен, если по маске уже выпущены документы': '若已按该掩码签发文件则不可更改',
  'Запись появится вместе с серверными командами': '写入功能将随服务端命令一并推出',
  'Заполните заказ, поставщика и предмет поставки': '请填写采购订单、供应商和供货内容',
  'Заполните и загрузите обратно.': '填写后再导入。',
  'Защищённое соединение · журнал аудита всех действий': '安全连接 · 全部操作留痕',
  'Значение…': '值…',
  'Из них просрочено': '其中逾期',
  'Изменение не отменено': '变更未取消',
  'Изменено строк': '已修改行数',
  'Изменить': '修改',
  'Изменить выбранные строки': '修改所选行',
  'Изменить выбранные': '修改所选',
  'Изменить реестр': '变更清单',
  'Изменяется': '变更中',
  'Исправить замечание': '修改意见',
  'Исправить своё замечание, пока шаг не закрыт': '在步骤关闭前修改自己的意见',
  'Код или наименование…': '代码或名称…',
  'Маршрут не назначен': '流程未指派',
  'Наследует маршрут дисциплины': '继承该专业的流程',
  'Объект / площадка': '区域 / 场地',
  'Объект берётся из титула': '区域取自项目标题',
  'Объект проекта': '项目区域',
  'Поиск по справке…': '在帮助中检索…',
  'Попробуйте другое слово — поиск идёт и по тексту статей.': '换个词试试——检索同时覆盖条目正文。',
  'Своего маршрута у ветки нет — показан маршрут дисциплины. «Сохранить маршрут» заведёт ветку': '该分支没有自己的流程——显示的是该专业的流程。点击「保存流程」将创建分支',
  'Своя ветка': '独立分支',
  'Сначала входной контроль: комплектность, ревизии, исходники и штампы. Панель приёмки — ниже, под списком документов.': '请先完成入库检验：完整性、版次、源文件和图签。验收面板位于文件清单下方。',
  'Сначала пакет проходит входной контроль — панель приёмки ниже, под списком документов.': '该文件包需先通过入库检验——验收面板位于文件清单下方。',
  'Сохранить исправление': '保存修改',
  'Изменить карточку': '修改卡片',
  'Изменить организацию': '修改单位',
  'Импорт': '导入',
  'Импорт реестра': '清单导入',
  'Импорт…': '导入中…',
  'Исполнитель': '执行人',
  'Исторический реестр': '历史清单',
  'История ревизий и версий': '版次与版本历史',
  'Источник': '来源',
  'Источник (TRM)': '来源传递单',
  'Исходящие': '发件',
  'Исходящий': '发出',
  'Итераций / док.': '每份文件轮次',
  'Итог. код': '最终代码',
  'Итоговый код — худший из голосов рецензентов': '最终代码取审查人意见中最差的一个',
  'К рассмотрению': '待审查',
  'К реестру': '返回清单',
  'Каждая строка двигается от своего прогноза, а нет прогноза — от плана': '每一行按自身预测顺延；没有预测时按计划顺延',
  'Карточка MDR': 'MDR 卡片',
  'Карточка VDR': 'VDR 卡片',
  'Классический': '经典',
  'Код': '编码',
  'Код не меняется': '编码不可更改',
  'Код проекта': '项目编码',
  'Код рассмотрения': '审查代码',
  'Код реестра сервер собирает из дисциплины и объекта. Номера документов выдаются при их создании. Справочники — в «Администрирование».': '清单编码由服务端按专业和区域生成；文件编号在创建时分配。字典维护见“系统管理”。',
  'Код реестра сервер собирает из контракта: реестр на контракт один и содержит все его документы. Дисциплина — у каждой строки реестра. Контракты и справочники — в «Администрирование».': '清单编码由服务器按合同生成：每份合同一份清单，包含其全部文件。专业属于清单中的每一行。合同与字典在“系统管理”中维护。',
  'Код снят с обращения': '该编码已停用',
  'Кодирование': '编码规则',
  'Коды выбираются явно — значений по умолчанию нет': '代码需显式选择——没有默认值',
  'Колонки': '列',
  'Колонки таблицы': '表格列',
  'Колонки файла не разобраны': '文件中有未识别的列',
  'Комплектность по назначениям': '按用途统计完成度',
  'Комплектность по реестрам MDR': 'MDR 清单完成度',
  'Комплектность: получено → на рассмотрении → согласовано (AFD)': '已接收 → 审查中 → 已批准（AFD）',
  'Комплекты ИД': '竣工资料交付包',
  'Контакт': '联系人',
  'Контрагент': '相对方',
  'Контракт': '合同',
  'Контракт · стадия · титул': '合同 · 阶段 · 标段',
  'Контракт · стадия · титул · дисциплина': '合同 · 阶段 · 标题 · 专业',
  'Контроль сроков': '进度管控',
  'Критичность': '重要程度',
  'Кто': '身份',
  'Лента активности': '动态',
  'Любая': '任意',
  'Любая колонка': '任意列',
  'Любое значение': '任意值',
  'Любой статус': '任意状态',
  'Маршрут для дисциплины': '该专业的审查流程',
  'Маршрут загружен из Excel': '流程已从 Excel 导入',
  'Маршрут рассмотрения ещё не назначен': '尚未指定审查流程',
  'Маски нумерации': '编号掩码',
  'Маски нумерации не настроены': '尚未配置编号掩码',
  'Матрица распределения': '分发矩阵',
  'Меняем…': '修改中…',
  'Метка': '标签',
  'Мои действия': '我的待办',
  'Мои документы': '我的文件',
  'Мои задачи': '我的任务',
  'Мои трансмитталы': '我的传递单',
  'Мои фильтры': '我的筛选',
  'Мой реестр MDR': '我的 MDR 清单',
  'На доработке': '退回修改',
  'На рассмотрении': '审查中',
  'На согласование за неделю': '本周送审',
  'На согласование': '提交审批',
  'На этой версии замечаний по разметке нет.': '该版本没有图面标注意见。',
  'На этой неделе': '本周',
  'Назад': '上一页',
  'Название под тем же именем перезапишет прежний отбор': '使用同一名称保存将覆盖此前的筛选',
  'Название': '名称',
  'Назн.': '用途',
  'Назначение': '用途',
  'Назначение выпуска': '签发用途',
  'Назначить маршрут по матрице': '按矩阵指派流程',
  'Наименование': '名称',
  'Наименование (EN)': '名称（英文）',
  'Наименование маски': '掩码名称',
  'Наименование реестра': '清单名称',
  'Найдено': '找到',
  'Накопленный выпуск: план / прогноз / факт': '累计签发：计划 / 预测 / 实际',
  'Наложение': '叠加',
  'Напр.: Насосный агрегат ЦН-12': '例如：泵机组',
  'Напр.: План трасс эстакады, лист 6': '例如：图纸名称',
  'Направление': '方向',
  'Например: объём сокращён по ДС №3': '例如：按补充协议 №3 缩减范围',
  'Например: просрочено по PI': '例如：PI 专业逾期',
  'Настройки аккаунта': '账号设置',
  'Настройки уведомлений': '通知设置',
  'Начато изменение реестра': '已开始变更清单',
  'Не все шаги маршрута пройдены': '流程步骤尚未全部完成',
  'Не выбрано': '未选中',
  'Не вышло': '未成功',
  'Не сдвинуто': '未顺延',
  'Не сохранилось': '未保存',
  'Не у каждого документа есть итоговый код': '仍有文件没有最终代码',
  'Не удалось загрузить': '加载失败',
  'Не удалось загрузить S-кривую': 'S 曲线加载失败',
  'Не удалось загрузить данные с сервера': '无法从服务器加载数据',
  'Не удалось загрузить документ': '文件加载失败',
  'Не удалось загрузить документы': '文件列表加载失败',
  'Не удалось загрузить заказы': '采购订单加载失败',
  'Не удалось загрузить замечания': '意见加载失败',
  'Не удалось загрузить историю ревизий': '版次历史加载失败',
  'Не удалось загрузить карточку': '卡片加载失败',
  'Не удалось загрузить ленту активности': '动态加载失败',
  'Не удалось загрузить очередь': '队列加载失败',
  'Не удалось загрузить показатели': '指标加载失败',
  'Не удалось загрузить поток документов': '文件流量加载失败',
  'Не удалось загрузить просроченные документы': '逾期文件加载失败',
  'Не удалось загрузить рассмотрение': '审查数据加载失败',
  'Не удалось загрузить реестры': '清单加载失败',
  'Не удалось загрузить список файлов': '文件列表加载失败',
  'Не удалось загрузить трансмитталы': '传递单加载失败',
  'Не удалось отобразить PDF': 'PDF 显示失败',
  'Не удалось получить список проектов': '项目列表加载失败',
  'Не удалось сравнить PDF': '比对失败',
  'Неизменяемый аудит-трейл': '不可篡改的审计留痕',
  'Нет документов': '暂无文件',
  'Нет документов по заданным фильтрам': '没有符合过滤条件的文件',
  'Нет задач по выбранному фильтру. Все действия выполнены.': '没有符合过滤条件的任务，全部处理完毕。',
  'Нет замечаний по заданным фильтрам': '没有符合过滤条件的意见',
  'Нет строк': '暂无数据',
  'Нет трансмитталов': '暂无传递单',
  'Ничего не найдено': '未找到任何内容',
  'Новая организация': '新增单位',
  'Новый проект': '新建项目',
  'Новый проект документооборота': '新建文档管理项目',
  'Номер PO': '采购订单号',
  'Номер заказа (PO)': '采购订单',
  'Номер контракта': '合同号',
  'Номер реестра': '清单编号',
  'Номер собирается на сервере: объект · дисциплина · код типа · следующий порядковый. Можно задать вручную.': '编号由服务端生成：区域 · 专业 · 类型代码 · 下一顺序号，可手工指定。',
  'Номер страницы': '页码',
  'Номер, ревизия, статус и фактическая дата правке не подлежат: их выводит документооборот.': '编号、版次、状态和实际日期不可编辑：由流程推导得出。',
  'Нужен документ и текст замечания': '需要选定文件并填写意见内容',
  'Нужен код по каждому документу': '每份文件都需要一个代码',
  'Нужен ответ': '待回复',
  'Нужны две загруженные версии': '需要两个已上传的版本',
  'Нужны код и наименование': '需要填写编码和名称',
  'Обзор': '概览',
  'Общий срок документа': '文件总期限',
  'Объект': '区域',
  'Объект / площадка (из титула)': '区域（取自标题）',
  'Ожидается ответ подрядчика (ACSR)': '等待承包商回复（ACSR）',
  'Опишите, как учтено замечание…': '请说明该意见的处理方式…',
  'Основная навигация': '主导航',
  'Основного файла нет': '没有主文件',
  'Основной файл загружен — открыть': '主文件已上传——点击打开',
  'Ответ на замечание (ACSR)': '意见回复（ACSR）',
  'Ответ отправлен, ожидает проверки заказчиком': '回复已发送，等待业主确认',
  'Ответственный:': '负责人：',
  'Отвечено': '已回复',
  'Отклонение': '偏差',
  'Отклонение, дн.': '偏差，天',
  'Отклонено': '已驳回',
  'Открытые': '未关闭',
  'Открытые замечания по документам подрядчика': '该承包商文件的未关闭意见',
  'Открытых': '未关闭',
  'Открыть журнал аудита': '打开审计日志',
  'Открыть на документе': '在图纸上打开',
  'Открыть реестр': '打开清单',
  'Отмена': '取消',
  'Отменить изменение': '取消变更',
  'Отменяется, пока состав не тронут: иначе изменение доводят до согласования': '只要内容未改动即可取消；否则须将变更走完审批',
  'Отправитель': '发件方',
  'Отправить заказчику': '发送给业主',
  'Отправить ответ': '发送回复',
  'Отправка…': '发送中…',
  'Отправлен': '已发送',
  'Отправляется…': '发送中…',
  'Отсортировано по длительности ожидания': '按等待时长排序',
  'Отстаёт от базового плана': '落后于基准计划',
  'Отчёты': '报表',
  'Отчёты и выгрузки': '报表与导出',
  'Очередь пуста': '队列已清空',
  'Очередь рассмотрения': '审查队列',
  'Очередь рассмотрения пуста': '审查队列为空',
  'Ошибка импорта': '导入错误',
  'Пакет создан, файл не ушёл': '文件包已创建，附件未上传',
  'Пакеты работ': '工作包',
  'Паралл.': '并行',
  'Параллельно': '并行',
  'Параллельные шаги рассмотрения выполняются одновременно; замечания консолидирует координатор ДО. При просрочке SLA задача эскалируется.': '并行步骤同时进行；由文控协调员汇总意见。SLA 逾期的任务将升级处理。',
  'Передать шаблон': '移交模板',
  'Передаём…': '发送中…',
  'Персональная очередь — то, что ждёт вашего решения': '个人队列——等待您处理的事项',
  'Печатается в бланке трансмиттала': '打印在传递单表格中',
  'План': '计划',
  'План (дата)': '计划日期',
  'План на сегодня': '截至今日计划',
  'Плотность': '行距',
  'Плотные строки: включены': '紧凑行距：已开启',
  'Плотные строки: выключены': '紧凑行距：已关闭',
  'По действию': '按操作',
  'По дисциплине': '按专业',
  'По сроку': '按期限',
  'По умолчанию (все дисциплины)': '默认（全部专业）',
  'Подготовить ответ (ACSR)': '准备回复（ACSR）',
  'Подрядчик': '承包商',
  'Подрядчик (документация проекта, MDR)': '承包商（项目文件，MDR）',
  'Подрядчик · внешний доступ': '承包商 · 外部访问',
  'Подрядчик · ответ': '承包商 · 回复',
  'Подрядчику уйдёт трансмиттал с файлом-шаблоном реестра': '承包商将收到附带清单模板文件的传递单',
  'Позже / без срока': '稍后 / 无期限',
  'Поиск': '搜索',
  'Поиск замечаний…': '搜索意见…',
  'Поиск по документу…': '搜索文件…',
  'Поиск по журналу…': '搜索日志…',
  'Поиск по номеру и наименованию…': '按编号或名称搜索…',
  'Поиск по №, наименованию, TRM…': '按编号、名称、TRM 搜索…',
  'Поиск по № TRM, теме, отправителю…': '搜索传递单…',
  'Поиск по № документа, TRM, CRS…': '搜索文件、TRM、CRS…',
  'Поиск по № документа, наименованию, TRM, замечанию…': '搜索…',
  'Поиск по № или наименованию…': '按编号或名称搜索…',
  'Пока ничего нет': '暂时还没有内容',
  'Поле сохраняется, когда из него уходит фокус. Состав номера не редактируется: по нему уже выданы номера документов.': '字段在失去焦点时保存。编号构成不可编辑：已按其分配过文件编号。',
  'Получатель': '收件方',
  'Получено (вх. TRM)': '已接收',
  'Польз.': '用户',
  'Пользователи': '用户',
  'Портал подрядчика': '承包商门户',
  'Последовательно': '串行',
  'Последний столбец скрыть нельзя': '不能隐藏最后一列',
  'Поставщик': '供应商',
  'Поставщик / подрядчик': '供应商 / 承包商',
  'Поставщик оборудования (заказ, VDR)': '设备供应商（采购订单，VDR）',
  'Поставщики': '供应商',
  'Поставщики и подрядчики': '供应商与承包商',
  'Поставщику уйдёт трансмиттал с файлом-шаблоном реестра': '供应商将收到附带清单模板文件的传递单',
  'Поставьте булавку или обведите место на листе': '在图面上放置标记点或圈出位置',
  'Поток документов (вход / возврат)': '文件流量（接收 / 退回）',
  'Предмет поставки': '供货内容',
  'Предприятие': '厂区',
  'Предыдущая страница': '上一页',
  'Пригласить пользователя': '邀请用户',
  'Приглашение заводит запись сразу в Keycloak и в справочнике проекта — команды пока нет': '邀请会同时在 Keycloak 和项目名册中建档——该命令尚未实现',
  'Применить': '应用',
  'Пример': '示例',
  'Примечание': '备注',
  'Принято строк': '已创建行数',
  'Прикрепить файлы': '附加文件',
  'Загрузить папку': '上传文件夹',
  'Проверить файл': '校验文件',
  'Проверка файла реестра': '清单文件校验',
  'Проверка…': '校验中…',
  'Прогнать файл по правилам загрузки, ничего не создавая': '按导入规则试运行文件，不创建任何记录',
  'Прочитать все': '全部标为已读',
  'Пусто — 00': '留空即 00',
  'Пусто — 00; следующая появится после приёмки в AFD': '留空即 00；下一版次在 AFD 验收后出现',
  'Пустое поле не меняется. План правится только в наполняемом реестре: в согласованном срок двигают изменением реестра.': '留空的字段不会被改动。计划只能在填报中的清单里修改：已批准清单的期限须通过清单变更顺延。',
  'Работа по реестру окончена: состав больше не меняется': '该清单的工作已结束：内容不再变动',
  'Работа по реестру продолжается': '该清单的工作仍在继续',
  'У ветки свой маршрут: правка общего маршрута дисциплины её не касается': '该分支有自己的流程：修改该专业的通用流程不会影响它',
  'Укажите объект: он входит в номер документа': '请指定对象：它计入文件编号',
  'Укажите титул: он входит в номер документа': '请指定项目标题：它计入文件编号',
  'Файлы к документам': '文件附件',
  'Форма TRM (xlsx)': 'TRM 表单（xlsx）',
  'Сначала выберите документы': '请先选择文件',
  'Трансмиттал': '传递单',
  'Тема': '主题',
  'Собираем…': '打包中…',
  'Пакет собран': '打包完成',
  'Пакет не собран': '打包失败',
  'Прикрепить листы CRS': '附加 CRS 意见单',
  'Листы замечаний CRS': 'CRS 意见单',
  'Лист замечаний': '意见单',
  'Исходящий TRM': '外发 TRM',
  'Подготовил': '编制人',
  'Автор': '作者',
  'Лист': '图页',
  'Печать': '打印',
  'занят': '占用',
  'рев.': '版次',
  'файл(ов)': '个文件',
  'Копировать': '复制',
  'Готово': '完成',
  'Вход': '登录名',
  'Вход создан': '登录已创建',
  'Временный пароль': '临时密码',
  '— не выбран —': '— 未选择 —',
  '— роль —': '— 角色 —',
  'Учётка': '账号',
  'Доступен один проект. Остальные назначает администратор.': '仅有一个可用项目。其余由管理员分配。',
  'Выгружено начало журнала': '已导出日志开头部分',
  'Версия': '版本',
  'Причина': '原因',
  'Причина обязательна': '必须填写原因',
  'Приёмка и рассмотрение документации EPC-подрядчика': 'EPC 承包商文件的接收与审查',
  'Прогноз': '预测',
  'Просмотр и разметка': '查看与标注',
  'Просроч.': '逾期',
  'Просроченные CRS': '逾期 CRS',
  'Просроченные документы': '逾期文件',
  'Просроченные документы — на эскалацию': '逾期文件——需升级处理',
  'Просроченных документов нет.': '没有逾期文件。',
  'Просрочено': '逾期',
  'Профиль': '个人资料',
  'Пункт НТД': '规范条款',
  'Пустой файл': '空文件',
  'Развернуть меню': '展开菜单',
  'Развернуть полку замечаний': '展开意见栏',
  'Раздел в разработке в этом прототипе.': '该模块在本原型中尚未实现。',
  'Разделитель': '分隔符',
  'Различия': '差异',
  'Разметка': '标注',
  'Разметка ставится поверх загруженного файла': '标注需基于已上传的文件',
  'Разнести файлы по строкам реестра по номеру в имени': '按文件名中的编号把文件分派到清单各行',
  'Рассм.': '审查',
  'Рассмотрение': '审查',
  'Рассмотрение по матрице распределения': '按分发矩阵审查',
  'Расширенный поиск': '高级搜索',
  'Рев.': '版次',
  'Ревизии': '版次',
  'Ревизий нет': '暂无版次',
  'Ревизия': '版次',
  'Ревизия / версия': '版次 / 版本',
  'Ревизия / лист': '版次 / 图号',
  'Ревизия создаётся при поступлении трансмиттала с документом.': '当载有该文件的传递单到达时创建版次。',
  'Реестр': '清单',
  'Реестр MDR': 'MDR 清单',
  'Реестр VDR': 'VDR 清单',
  'Реестр VDR / заказы на поставку': 'VDR 清单 / 采购订单',
  'Реестр замечаний': '意见清单',
  'Реестр подан на согласование': '清单已提交审批',
  'Реестр уже подан или согласован': '清单已提交或已批准',
  'Реестр уйдёт заказчику трансмитталом и встанет на рассмотрение': '清单将以传递单发给业主并进入审查',
  'Реестр, дисциплина, титул…': '清单、专业、标段…',
  'Реестров пока нет': '暂无清单',
  'Реестры по дисциплинам': '按专业分列的清单',
  'Рендеринг и сравнение…': '渲染与比对中…',
  'Рецензент': '审查人',
  'Рецензенты рассматривают одновременно, координатор ДО консолидирует': '审查人并行审查，由文控协调员汇总',
  'Решение по ответу:': '处理决定：',
  'Роли и доступ': '角色与权限',
  'Роль': '角色',
  'Роль (описание)': '角色（说明）',
  'Рядом': '并排',
  'С ответом': '已回复',
  'С ошибками': '有错误',
  'Сброс': '重置',
  'Сбросить': '重置',
  'Сведения': '详情',
  'Сведения о заказе на поставку': '采购订单详情',
  'Сведения о трансмиттале': '传递单详情',
  'Свернуть меню': '收起菜单',
  'Свернуть полку замечаний': '收起意见栏',
  'Сводка': '汇总',
  'Связанный реестр MDR': '关联的 MDR 清单',
  'Сдвинуть сроки, не назначая общей даты': '顺延期限而不指定统一日期',
  'Сдвинуть': '顺延',
  'Сегодня / 2 дня': '今天 / 2 天内',
  'Сервер не ответил. Это не значит, что проектов нет.': '服务器没有响应。这并不表示没有项目。',
  'Скачать': '下载',
  'Скачать пакет': '下载压缩包',
  'Следующая страница': '下一页',
  'Словами ничего не найдено — обрывок номера ищет список реестра ниже. Поиск по словам понимает падежи и не зависит от порядка слов; точная фраза — в кавычках, исключение — со знаком минус.': '按词未找到内容 —— 编号片段由下方的清单列表检索。按词检索识别词形变化且不依赖词序；精确短语加引号，排除项加减号。',
  'Сменить проект': '切换项目',
  'Сменить учётную запись': '切换账号',
  'Сначала выберите заказ': '请先选择订单',
  'Сначала выберите реестр': '请先选择清单',
  'Сначала загрузите состав реестра': '请先导入清单内容',
  'Снять': '清除',
  'Снять последнюю фигуру': '撤销上一个图形',
  'Согласован': '已批准',
  'Содержание': '主题',
  'Создать MDR': '新建 MDR',
  'Создать VDR под PO': '按采购订单新建 VDR',
  'Создать документ': '新建文件',
  'Создать и отправить': '创建并发送',
  'Создать проект': '新建项目',
  'Создать реестр': '创建清单',
  'Создать реестр MDR': '创建 MDR 清单',
  'Создать реестр VDR': '创建 VDR 清单',
  'Создаём…': '创建中…',
  'Состав загружают файлом реестра («Проверить файл») или заводят строкой — «Создать документ».': '清单内容可用清单文件导入（“校验文件”），也可逐行录入 ——“新建文件”。',
  'Состав назначается один раз по матрице распределения': '审查人员按分发矩阵一次性指派',
  'Состав приходит трансмитталом от поставщика. Передайте ему шаблон реестра или загрузите состав файлом.': '内容由供应商以传递单送来。请向其移交清单模板，或用文件导入内容。',
  'Состав рассмотрения ещё не назначен. Маршрут берётся из матрицы распределения по области трансмиттала.': '尚未指派审查人员。流程取自该传递单范围对应的分发矩阵。',
  'Состав реестра закрыт: он согласован или на рассмотрении': '清单内容已锁定：已批准或正在审查',
  'Состав снова откроется; согласованная редакция остаётся действующей до нового согласования': '内容将重新开放；已批准的版次在新的批准前继续有效',
  'Сохранение…': '保存中…',
  'Сохранить': '保存',
  'Сохранить маршрут': '保存流程',
  'Сохранить отбор': '保存筛选',
  'Сохранить текущий отбор': '保存当前筛选',
  'Сохранённые фильтры': '已保存的筛选',
  'Справка и поддержка': '帮助与支持',
  'Справочники': '字典',
  'Справочники системы': '系统字典',
  'Ср. ожидание': '平均等待',
  'Сравнение': '比对',
  'Срок': '期限',
  'Срок выпуска': '签发期限',
  'Срок на неделе': '本周到期',
  'Срок ответа': '回复期限',
  'Срок ≤ 2 дней': '期限 ≤ 2 天',
  'Сроки под контролем': '进度受控',
  'Сроки сдвинуты': '期限已顺延',
  'Стадия': '阶段',
  'Стадия проектирования': '设计阶段',
  'Стало': '变更后',
  'Статус': '状态',
  'Статус подачи / согласования': '提交 / 批准状态',
  'Статус подачи и согласования по реестрам MDR': '按 MDR 清单统计的提交与批准状态',
  'Столбец опознаёт запись — скрыть нельзя': '该列用于识别记录，无法隐藏',
  'Строк прошло': '通过的行数',
  'Строка MDR': 'MDR 行号',
  'Строка удалена': '该行已删除',
  'Строки аннулированы': '所选行已作废',
  'Строки изменены': '所选行已修改',
  'Сформировать TRM': '生成传递单',
  'Сформировать входящий трансмиттал': '生成接收传递单',
  'Сформировать исходящий TRM': '生成外发传递单',
  'Сформировать трансмиттал': '生成传递单',
  'Счётчики считаются по всему реестру и запрос не учитывают, поэтому при запросе не показываются.': '计数按整个清单统计，不考虑当前查询词，因此输入查询时不显示。',
  'Текст замечания': '意见内容',
  'Текст замечания…': '意见内容…',
  'Текст ответа': '回复内容',
  'Тип': '类型',
  'Тип документа': '文件类型',
  'Тип рассмотрения': '审查类型',
  'Титул': '标题',
  'Титул проекта': '项目标题',
  'Титул проекта (объект по умолчанию)': '项目标段（默认对象）',
  'Трансмиттал выпущен': '传递单已签发',
  'Трансмитталы': '传递单',
  'Трансмитталы контрагента': '该相对方的传递单',
  'У документа ещё нет ревизии — файлу некуда лечь.': '该文件尚无版次——文件无处存放。',
  'У документа ещё нет ревизий.': '该文件尚无版次。',
  'У заказа нет поставщика: шаблон некому передавать': '该订单没有供应商：模板无人可交',
  'У реестра дисциплины нет — выберите': '该清单没有专业 —— 请选择',
  'У реестра нет подрядчика: шаблон некому передавать': '该清单没有承包商：模板无人可交',
  'Уведомления': '通知',
  'Увеличить': '放大',
  'Уменьшить': '缩小',
  'Удаление…': '删除中…',
  'Удалить': '删除',
  'Удалить трансмиттал': '删除传递单',
  'Трансмиттал удалён': '传递单已删除',
  'Удалить реестр': '删除清单',
  'Удалить фильтр': '删除筛选',
  'Укажите дисциплину: у реестра её нет': '请指定专业：该清单没有专业',
  'Укажите наименование документа': '请填写文件名称',
  'Укажите наименование реестра': '请填写清单名称',
  'Файл': '文件',
  'Файл действующего проекта: прошедшие сроки, состояние и код принимаются как есть': '在建项目的文件：过往日期、状态和审查编码按原样接收',
  'Файл не загружен': '未上传文件',
  'Файл не прочитан': '无法读取文件',
  'Файл недоступен': '文件不可用',
  'Файл пройдёт загрузку целиком: ни одна строка не отклонена.': '文件可完整导入：没有任何一行被拒绝。',
  'Файлов у документа ещё нет': '该文件尚无附件',
  'Файлы': '文件',
  'Файлы пакетом': '批量文件',
  'Фильтры': '筛选',
  'Файлы прикладываются в карточке документа — трансмиттал ссылается на уже загруженные версии.': '附件在文件卡片中上传——传递单只引用已上传的版本。',
  'Факт': '实际',
  'Факт на сегодня': '截至今日实际',
  'Фокус': '重点',
  'Формируем…': '生成中…',
  'Хронология': '时间线',
  'Цикл рассмотрения': '审查周期',
  'Черновик': '草稿',
  'Читаем состав реестра…': '正在读取清单内容…',
  'Чтение…': '读取中…',
  'Что двигаем': '顺延对象',
  'Что именно не так и что требуется исправить…': '问题是什么，需要如何修改…',
  'Что ожидает действий с вашей стороны': '等待您处理的事项',
  'Шаблон': '模板',
  'Шаблон выгружен': '模板已导出',
  'Шаблон не передан': '模板未移交',
  'Шаблон номера': '编号模板',
  'Шаблон передан': '模板已移交',
  'Шаг 1 · Выбор проекта': '第 1 步 · 选择项目',
  'Шаг закроется, следующий станет активным': '关闭本步骤并激活下一步',
  'Экспорт': '导出',
  'Эскал., дн': '升级，天',
  'Эскалация ГИП при превышении SLA': '超出 SLA 后升级至总工',
  'Эскалация при просрочке —': '逾期升级至 —',
  'Эскалация просрочек': '逾期升级',
  'Эскалировать': '升级',
  'Эти настройки в маршруте не хранятся: сервер держит роль, исполнителя, действие и SLA.': '这些设置不会随流程保存：服务端只保留角色、执行人、操作和 SLA。',
  'авто': '自动',
  'без изм.': '无变化',
  'версий: ': '版本数：',
  'версия': '版本',
  'вручную': '手动',
  'выбрано': '已选',
  'выдаст сервер': '由服务端分配',
  'дн': '天',
  'добавлено': '已新增',
  'док. · отв.': '份文件 · 负责人',
  'док.': '份文件',
  'документов': '份文件',
  'замечаний': '条意见',
  'записей': '条记录',
  'из': '/',
  'код по каждому документу': '每份文件一个代码',
  'консолидировано': '已汇总',
  'лист': '页',
  'напр. ГОСТ 21.201, п. 5.2': '例如 ISO 128，第 5.2 条',
  'например: заведён по ошибке': '例如：误建',
  'не задаётся': '不可配置',
  'не менять': '不修改',
  'нет': '无',
  'новых': '新增',
  'ожидание': '等待中',
  'от': '来自',
  'отправлен': '已发送',
  'очистить': '清除',
  'параллельно': '并行',
  'проср.': '逾期',
  'расчёт': '计算值',
  'ревизий нет': '暂无版次',
  'срок': '期限',
  'строк': '行',
  'строка': '行',
  'только что': '刚刚',
  'удалено': '已删除',
  'шаги выполняются по порядку': '步骤按顺序执行',
  'эскалация на ': '升级至 ',
  '— из реестра —': '— 取自清单 —',
  '— не задан —': '— 未设置 —',
  '— не задан (0000) —': '— 未设置（0000）—',
  '— не менять —': '— 保持不变 —',
  '— не назначен': '— 未指派',
  '№ документа': '文件编号',
  '№ документа (пусто = авто)': '文件编号（留空 = 自动）',

  /* Подписи, которые уходят в t() переменными — пункты навигации, коды
     рассмотрения, инструменты разметки, шаги загрузки. В вызове на их месте
     стоит `n.ru`, а не строка, поэтому в общий разбор они не попадают. */
  'CRS / ACSR': 'CRS / ACSR',
  'Аналитика': '统计分析',
  'Документация': '文档',
  'Документы MDR': 'MDR 文件',
  'Дополнительный': '附加',
  'Доработать': '修改后重报',
  'Замечания CRS': 'CRS 意见',
  'Исходник': '原件',
  'Маршрут хранит роль, исполнителя, действие и SLA — это поле не сохраняется': '流程只保存角色、执行人、操作和 SLA——该字段不会保存',
  'Обзор проекта': '项目概览',
  'Основной': '主文件',
  'Принято': '已接受',
  'Принято с замеч.': '有意见接受',
  'Рабочее место': '工作台',
  'Реестр VDR / PO': 'VDR 清单 / 采购订单',
  'Реестры MDR': 'MDR 清单',
  'Реестры VDR': 'VDR 清单',
  'загружаем': '上传中',
  'линия': '直线',
  'облако': '云线',
  'подписываем': '签名中',
  'прямоугольник': '矩形',
  'регистрируем': '登记中',
  'стрелка': '箭头',
  'текст': '文字',
  'штамп': '图章',

  /* Кодирование и учётные записи (13.08.26). */
  'Маска номера документа': '文件编号掩码',
  'По ней нумеруются документы реестра': '清单内文件按此掩码编号',
  'Новая маска документа': '新建文件编号掩码',
  'Состав номера задаётся следом, на самой маске.': '编号组成随后在掩码本身设置。',
  'Сегмент': '字段',
  'Сохранить состав': '保存组成',
  'Значение': '取值',
  'Выше': '上移',
  'Ниже': '下移',
  'Убрать': '移除',
  'Маска с выпущенными документами заморожена — заведите новую и переведите на неё реестр': '已签发文件的掩码被冻结——请新建掩码并将清单切换过去',
  'Поля маски сохраняются, когда из них уходит фокус; состав номера — кнопкой «Сохранить состав».': '掩码字段在失去焦点时保存；编号组成用“保存组成”按钮保存。',
  'Номер собирается на сервере по маске этого реестра. Можно задать вручную.': '编号由服务端按本清单的掩码生成，也可手工指定。',
  'Объект реестра': '清单区域',
  'Дисциплина реестра': '清单专业',
  'Порядковый номер': '流水号',
  'Постоянная строка': '固定字符',
  'Год': '年份',
  'Заказ на поставку': '采购订单',
  'Новая учётная запись': '新建账号',
  'Изменить учётную запись': '修改账号',
  'Добавить пользователя': '新增用户',
  'Имя': '姓名',
  'Имя входа': '登录名',
  'Почта': '邮箱',
  'оставить прежнее': '保持不变',
  'Внешний участник (подрядчик)': '外部参与方（承包商）',
  'повторная подача': '重复提交',
  'подрядчик не указан': '未指定承包商',
  'ред. ': '修订 ',
  'реестров': '份清单',
  '— не выбрана —': '—— 未选择 ——',
  '— организация —': '— 单位 —',
  'Приглашён': '已邀请',
  'Активен': '启用',
  'Заводится участник проекта. Сам вход создаётся в Keycloak: пока его нет, человек не получит токен.': '此处创建的是项目参与方。登录账号在 Keycloak 中创建：没有它就拿不到令牌。',
  'Подача': '提交次',
  'Ревизия и подача': '版次与提交次',
  'Выпущено на': '提出于',
  'Страница': '页',
  'Выгрузить': '导出',
  'Загрузить перевод': '导入翻译',
  'прошлый круг': '上一轮',
  'Замечания по версиям': '按版本查看意见',
  'Править формулировки': '修改措辞',
  'Сохранить все': '全部保存',
  'На основе': '基于此条',
  'сохраняется целиком': '整体保存',
  'этот лист': '本页',
  'Текст перенесён': '文本已转入',
  'Замечание закрыто': '意见已关闭',
  'По документу замечаний нет': '该文件没有意见',
  'Запустить': '待启动',
  'Идёт': '进行中',
  'Завершены': '已完成',
  'В этой стадии пакетов нет': '此阶段没有传递单',
  'закрыто': '已关闭',
  'снято': '已撤回',
  'есть ответ': '已答复',
  'открыто': '未关闭',
  'ваше': '本人',
  'Замещения': '代班安排',
  'Завести замещение': '新建代班',
  'Замещение на время отсутствия': '缺席期间的代班',
  'Замещений нет': '暂无代班',
  'Замещение отозвано': '代班已撤销',
  'Замещение заведено': '代班已建立',
  'Отозвать': '撤销',
  'Завести': '建立',
  'Отсутствующий': '缺席人',
  'Замещающий': '代理人',
  'Отсутствует с': '缺席自',
  'По включительно': '至（含）',
  'последний день замещения': '代班的最后一天',
  'не указана': '未填写',
  'Действует': '生效中',
  'Ожидает': '待生效',
  'Истекло': '已到期',
  'отпуск, больничный, командировка': '休假、病假、出差',
  'Нужны замещающий и обе даты': '需要填写代理人和两个日期',
  'право подписи передаёт только его владелец': '签署权只能由其本人转交',
  'На срок приказа шаги отсутствующего ведёт замещающий, получая и права его разделов. Шаги не переназначаются.': '在代班期间，缺席人的步骤由代理人处理，并获得其板块权限。步骤本身不会被改派。',
  'Здесь только ваши приказы: где отсутствующий вы и где замещающий вы. Передать вправе только владелец права.': '此处只显示与您相关的代班：您为缺席人或您为代理人。权限只能由其本人转交。',
  'Ушедший в отпуск оставляет шаги висеть до возвращения. Приказ передаёт право их вести на срок отсутствия — и снимает его сам, без второго захода.': '休假的人会让自己的步骤一直挂到回来为止。代班在缺席期间把处理权转交出去，并到期自动失效，无需再操作一次。',
  'Администратора не замещают: у него не работа в круге, а ключи от системы.': '管理员不可被代班：他掌握的是系统钥匙，而不是审查环节中的工作。',
  'Своих прав он не теряет: замещение расширяет принадлежность шага, а не подменяет человека.': '代理人不会失去自己的权限：代班扩大了步骤的归属，而不是替换某个人。',
  'Свободным текстом: закрытый список причин отсутствия пришлось бы вести, и он ничего не решает.': '自由填写：封闭的缺席原因清单需要维护，却解决不了任何问题。',
  'Цепочек нет: если замещающий сам уйдёт, приказ пишется на третьего от отсутствующего — права, которых никто не выдавал явно, не наследуются.': '不支持连环代班：如果代理人本人也离开，应由缺席人另行指定第三人——没有明确授予的权限不会被继承。',
  'Удалить файл из хранилища': '从存储中删除文件',
  'Удалить из хранилища': '从存储中删除',
  'Удалить файл из хранилища — байты стираются насовсем': '从存储中删除文件——字节将被永久抹除',
  'Файл удалён из хранилища': '文件已从存储中删除',
  'Причина удаления': '删除原因',
  'чужой договор, персональные данные, документ смежника…': '他人的合同、个人信息、相关方的文件…',
  'Всё равно удалить переданный файл': '仍然删除已发出的文件',
  'Байты стираются из хранилища насовсем — не «строка снята», а файла больше нет. Восстановить его неоткуда, отдать второй стороне повторно нечем, и в системе от него останется одна запись журнала.': '字节将从存储中被永久抹除——不是「撤下该行」，而是文件不复存在。无处可恢复，也无法再次交付给对方，系统中只会留下一条审计记录。',
  'Обязательна: после удаления объяснить файл будет нечем, кроме этой строки в журнале.': '必填：删除之后，除了日志中的这一行，再没有别的东西能解释这个文件。',
  'Файл уже ушёл трансмитталом и лежит у второй стороны. Удаление здесь её копию не отзовёт: у вас файла не станет, у неё он останется — и по журналу это будет расхождением с контрагентом, а не ошибкой загрузки.': '该文件已随传递单发出，现存于对方手中。在此删除并不会收回对方的副本：您这边文件消失，对方那边仍然保留——在日志中这将记为与相对方的不一致，而不是上传错误。',
  'Моё замещение': '我的代理',
  'Разбор книги…': '正在解析工作簿…',
  'Разбор документа…': '正在解析文档…',
  'Лист пуст': '工作表为空',
  'Файл не удалось разобрать': '文件解析失败',
  'Не удалось разобрать как книгу Excel': '无法作为 Excel 工作簿解析',
  'Не удалось разобрать как документ Word': '无法作为 Word 文档解析',
  'Новое замечание': '新建意见',
  'Сказано на этой подаче': '本次提交中提出的意见',
  'На этой подаче замечаний не было': '本次提交未提出意见',
  'Ваш шаг — утверждение: решение по замечаниям, а не выпуск': '您的环节是审批：对意见作出决定，而非提出意见',
  'Замечание выпускается внутри рассмотрения — там, где вам поручен шаг': '意见在审查过程中提出——在指派给您的环节上',
  'Свернуть полку': '收起侧栏',
  'Развернуть замечания прошлой подачи': '展开上次提交的意见',
  'Развернуть выпуск замечания': '展开新建意见栏',
  'Показать место на листе': '在图纸上显示位置',
  'исходник': '源文件',
  'вложение': '附件',
  'Отвечены': '已答复',
  'Закрыты': '已关闭',
  // Матрицы распределения: реестр веток и SLA по кругам (V96)
  'SLA 1 круг': 'SLA 第1轮',
  'SLA 2 круг': 'SLA 第2轮',
  'SLA 3+ круг': 'SLA 第3+轮',
  'Реестр матриц': '矩阵登记册',
  'Выгрузить все в Excel': '全部导出到Excel',
  'Редактор': '编辑器',
  'Ветка': '分支',
  'Шагов': '步骤数',
  'SLA по кругам': '各轮SLA',
  'Отличие': '差异',
  'базовый маршрут': '基础路线',
  'маршрута дисциплины': '专业路线',
  'совпадает с ': '等同于 ',
  'отличается от ': '不同于 ',
  'Сумма сроков шагов: 1-й / 2-й / 3-й+ круг': '步骤期限合计：第1/2/3+轮',
  'Открыть в редакторе': '在编辑器中打开',
  'Снять ветку': '移除分支',
  'Маршрут по умолчанию снять нельзя': '默认路线不可移除',
  'Маршрутов пока нет.': '尚无路线。',
  'Дисциплина без строки в реестре идёт маршрутом по умолчанию. Загрузка из Excel заменяет перечисленные в файле ветки целиком; не названные — не трогает.':
    '登记册中没有行的专业按默认路线走。Excel导入整体替换文件中列出的分支；未列出的不受影响。',
  'Загрузка матриц': '矩阵导入',
  'Применение…': '应用中…',
  'новая': '新增',
  'изменится': '将更改',
  'без изменений': '无变化',
  'Снять ветку маршрута': '移除路线分支',
  'Снятие…': '移除中…',
  'Ветка снята': '分支已移除',
  'Снять не удалось': '移除失败',
  'Матрицы выгружены': '矩阵已导出',
  'Матрицы загружены': '矩阵已导入',
  'Загрузка отклонена': '导入被拒绝',
  'Изменений нет': '无更改',
  'Файл совпадает с действующими матрицами.': '文件与现行矩阵一致。',
  'Файл не принят': '文件未被接受',
  'Неизвестные коды: ': '未知代码：',
  'В Excel не найдено строк.': '在Excel中未找到行。',
}
